import React from 'react';
import { Resolver } from 'react-hook-form';
import { DisabledFields } from 'types/disabledFields';
import { AccountingType } from 'v2-types/order';

import useAddRecipts from './add-entry-hooks';
import AddEntryScene from './add-entry-modal-scene';
import { EntryLedgerType } from './services/types';

type AddEntryProps = {
  open: boolean
  handleClose: () => void,
  prevData: AccountingType | null,
  kindAllowedEntry?: string | string[],
  codeAllowedEntry?: string | string[],
  mortgageId?: string,
  additionalamount?: number,
  resolver?: Resolver<EntryLedgerType, object> | undefined,
  hideFields?: DisabledFields<EntryLedgerType>
}

const AddPartyEntry = ({
  handleClose,
  open,
  prevData,
  kindAllowedEntry,
  codeAllowedEntry,
  resolver,
  mortgageId,
  additionalamount,
  hideFields
}: AddEntryProps) => {
  const {
    handleEntry,
    methods,
    allowedCodes,
    allowedKinds,
    createErrors,
    t,
    loadingEditEntry,
    loadingAddNewEntry
  } = useAddRecipts(
    handleClose,
    prevData,
    kindAllowedEntry,
    codeAllowedEntry,
    resolver,
    mortgageId
  );
  const { setValue, getValues, control } = methods;

  const closeModal = () => {
    methods.reset();
    handleClose();
  };

  const handleResetValue = () => {
    const amount_calculated = getValues('amount_calculated');
    setValue('amount_override', amount_calculated);
  };

  return (
    <AddEntryScene
      open={open}
      onClose={closeModal}
      control={control}
      handleSubmit={handleEntry}
      allowedCodes={allowedCodes || []}
      allowedKinds={allowedKinds || []}
      errors={createErrors}
      prevData={prevData}
      t={t}
      loadingAddNewEntry={loadingAddNewEntry}
      loadingEditEntry={loadingEditEntry}
      handleResetValue={handleResetValue}
      methods={methods}
      additionalamount={additionalamount}
      hideFields={hideFields}
    />
  );
};

export default AddPartyEntry;
